import { createSlice } from "@reduxjs/toolkit"

export const vendorSlice = createSlice({
    name: 'vendorData',
    initialState: { data: '' },
    reducers: {
        setRowData: (state, action) => {
            state.data = action.payload
        }
    }
})

export const { setRowData } = vendorSlice.actions

export default vendorSlice.reducer